import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID,
    IGroupItemCategoriesLoadByGroupIdAction,
    IGroupItemCategoriesLoadByGroupIdFailureAction,
    IGroupItemCategoriesLoadByGroupIdSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/groupItemCategory";
import { groupItemCategoryApi } from 'src/services/groupItemCategory';

export const
    getGroupItemCategoriesByGroupIdEpic = (action$): Observable<IGroupItemCategoriesLoadByGroupIdSuccessAction | IGroupItemCategoriesLoadByGroupIdFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID)
            .mergeMap((action: IGroupItemCategoriesLoadByGroupIdAction) => {
                return groupItemCategoryApi
                    .getGroupItemCategoriesByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupItemCategories, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }